/* eslint-disable ember/no-get */
import { helper } from '@ember/component/helper';
import { get } from '@ember/object';
import { getFieldOptions } from '@linc-technologies/linced-common/utils/fields';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export function labelForOption([field, value]) {
  // Get options from field or enum as appropriate
  let options = field.get('options');
  if (field.optionsFromEnum) {
    options = getFieldOptions(field.key);
  }

  let option = findBy(options, 'value', value);
  if (option) {
    return get(option, 'label');
  }
  return value;
}

export default helper(labelForOption);
